<header class="block w-full">

  <div class="hidden lg:block">
    <div class="header-topbar flex items-center justify-between gap-4 px-12 py-3 text-white">
      <div class="flex items-center gap-8.75 ml-auto">
        @if (usuario(); as sesion) {
          <app-account-access [user]="sesion" (signOut)="signOut()" />
        } @else {
          <a routerLink="/login"
            class="inline-flex items-center gap-2.5 py-1 pr-3.5 pl-1 border border-transparent rounded-full bg-transparent text-white text-(length:--fs-ui,0.75rem) no-underline cursor-pointer transition-colors duration-200 hover:border-(--blanco,#ffffff) font-ui">
            <span class="user-icon-avatar font-normal">
              <img src="/icons/user-solid.png" alt="Icono Usuario" class="user-icon-img" />
            </span>
            <span class="tracking-[0.04em]">INGRESAR</span>
          </a>
        }
        <a routerLink="/members"
          class="btn-socio inline-flex items-center justify-center px-5 py-2 gap-1 rounded-[10px] text-white text-xs font-bold tracking-wider no-underline cursor-pointer whitespace-nowrap">
          HAZTE SOCIO
        </a>
        <a routerLink="/store/cart" [attr.aria-label]="cartCount() ? 'Carrito de compras, ' + cartCount() + ' artículos' : 'Carrito de compras'"
          class="relative inline-flex shrink-0 cursor-pointer">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M7.5 18C8.32843 18 9 18.6716 9 19.5C9 20.3284 8.32843 21 7.5 21C6.67157 21 6 20.3284 6 19.5C6 18.6716 6.67157 18 7.5 18Z" fill="#F0F0F0" stroke="#F0F0F0" stroke-width="1.5"/>
            <path d="M16.5 18C17.3284 18 18 18.6715 18 19.5C18 20.3284 17.3284 21 16.5 21C15.6716 21 15 20.3284 15 19.5C15 18.6715 15.6716 18 16.5 18Z" stroke="#F0F0F0" stroke-width="1.5"/>
            <path d="M2 3L2.26121 3.09184C3.5628 3.54945 4.2136 3.77826 4.58584 4.32298C4.95808 4.86771 4.95808 5.59126 4.95808 7.03836V9.76C4.95808 12.7016 5.02132 13.6723 5.88772 14.5862C6.75412 15.5 8.14857 15.5 10.9375 15.5H12M16.2404 15.5C17.8014 15.5 18.5819 15.5 19.1336 15.0504C19.6853 14.6008 19.8429 13.8364 20.158 12.3075L20.6578 9.88275C21.0049 8.14369 21.1784 7.27417 20.7345 6.69708C20.2906 6.12 18.7738 6.12 17.0888 6.12H11.0235M4.95808 6.12H7" stroke="#F0F0F0" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
          @if (cartCount(); as total) {
            <span class="cart-badge" aria-hidden="true">{{ total > 9 ? '9+' : total }}</span>
          }
          <app-cart-countdown />
        </a>
      </div>
    </div>

    <div class="flex items-center justify-between py-3.5 px-12 bg-white w-full relative">
      <a class="inline-flex items-center gap-1.5 no-underline text-black shrink-0" routerLink="/">
        <img class="w-14 h-14 object-contain" src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/logo2.png" alt="Escudo Municipal" />
        <span class="flex flex-col gap-0.5">
          <span class="font-logo font-normal text-[9.08px] uppercase">
            CLUB CENTRO DEPORTIVO
          </span>
          <span class="font-body font-normal text-2xl uppercase leading-[0.95] tracking-tight text-center">
            MUNICIPAL
          </span>
          <div class="flex items-center gap-1.5 w-full mt-0.5">
            <span class="flex-1 h-[0.75px] bg-black"></span>
            <span class="font-logo font-normal text-[9.08px] leading-none text-black">1935</span>
            <span class="flex-1 h-[0.75px] bg-black"></span>
          </div>
        </span>
      </a>

      <nav aria-label="Navegación principal" class="flex-1 flex justify-center">
        <ul class="flex items-center gap-6 xl:gap-10 list-none m-0 p-0">
          <li><a routerLink="/history" class="nav-link">Historia</a></li>
          <li><a routerLink="/news" class="nav-link">Noticias</a></li>
          <li><a routerLink="/academy" class="nav-link">Academia</a></li>
          <li><a href="#" (click)="toggleMenu('plantel', $event)" class="nav-link"
              [class.nav-link--active]="activeMenu === 'plantel'">Planteles</a></li>
          <li><a href="#" (click)="toggleMenu('store', $event)" class="nav-link"
              [class.nav-link--active]="activeMenu === 'store'">Tienda</a></li>
          <li><a routerLink="/fixture" class="nav-link">Fixture</a></li>
          <li><a routerLink="/tickets" class="nav-link nav-link--ticket">Ticketera</a></li>
          <li><a routerLink="/abono-edil" class="nav-link">Abono Edil</a></li>
          <li><a routerLink="/sponsors" class="nav-link">La Camiseta de Todos</a></li>
        </ul>
      </nav>

      <div class="w-46.25 shrink-0 pointer-events-none opacity-0 hidden lg:block"></div>

      @if (activeMenu === 'store') {
        <app-mega-menu
          [config]="storeMenuConfig()"
          [isClosing]="isClosing"
          (closeMenu)="closeActiveMenu()" />
      }
      @if (activeMenu === 'plantel') {
        <app-mega-menu
          [config]="plantelMenuConfig()"
          [isClosing]="isClosing"
          (closeMenu)="closeActiveMenu()" />
      }
    </div>
  </div>

  <div class="mobile-header-bar flex lg:hidden items-center justify-between px-3 py-3.5 bg-azul-profundo w-full relative z-40"
    [class.mobile-header-bar--open]="isMobileMenuOpen">
    <a routerLink="/" class="inline-flex items-center shrink-0">
      <img src="https://deportivo-municipal.s3.us-east-2.amazonaws.com/assets/logo2.png" alt="Escudo Municipal" class="w-12 h-12 object-contain" />
    </a>

    <div class="flex items-center gap-1">
      @if (usuario(); as sesion) {
        <app-account-access [user]="sesion" [compact]="true"
          (profileOpened)="closeMobileMenu()" (signOut)="signOut()" />
      } @else {
        <a routerLink="/login" (click)="closeMobileMenu()"
          class="flex items-center gap-2 px-3 py-1 bg-gris-claro rounded-2xl text-black font-ui text-xs font-bold no-underline cursor-pointer select-none">
          <span class="w-[34px] h-5.75 flex items-center justify-center bg-gris-claro rounded-[10px] shrink-0">
            <img src="/icons/user-solid-2.png" alt="Icono Usuario" class="w-5 h-5 object-contain" />
          </span>
          <span class="tracking-[0.04em] uppercase text-black font-semibold">INGRESAR</span>
        </a>
      }

      <button (click)="toggleMobileMenu()"
        class="text-white p-1 flex items-center justify-center shrink-0"
        aria-label="Abrir menú">
        <svg width="35" height="35" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"
          stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg">
          <path d='M4.5 6.5h15M4.5 12h15m-15 5.5h15' />
        </svg>
      </button>
    </div>
  </div>

  <app-mobile-menu
    [isOpen]="isMobileMenuOpen"
    [mobileSubmenu]="mobileSubmenu"
    [storeMenuConfig]="storeMenuConfig()"
    [plantelMenuConfig]="plantelMenuConfig()"
    (closeMenu)="closeMobileMenu()"
    (toggleSubmenu)="toggleMobileSubmenu($event)"
  />

</header>
